const translations = {
    abandonAndCreate: 'Abandon & Create',
    abandonBoundary: 'Are you sure you want to abandon the current boundary for a new one?',
    back: 'Back',
    deleteAndStartOver: 'Delete & Start Over',
    leaveAndDiscard: 'Leave & Discard',
    leaveBeforeSave: 'Are you sure you want to leave before saving the boundary?',
    leaveWithoutCreating: 'Are you sure you want to leave? This boundary has not been created yet.',
    save: 'Save',
    startOver: 'Are you sure you want to delete and start over?'
};

export default translations;
